import { mapGetters } from "vuex";

export const common = {
  computed: {
    ...mapGetters([
      'permission',
    ]),
  },
  methods: {
    checkAuth(code) {
      return this.permission.includes(code);
    },
    /**
     * 解密
     * @param {*} pageType 页面类型 1保单详情 2订单详情 
     * @param {*} type 1身份证 2手机号 3银行卡 8投保地址 9邮箱
     * @param {*} id 
     * @param {*} key 回显的字段
     * @param {*} formData 回显的数据实体
     * @returns 
     */
    descrypt(pageType, type, md5, id, key, formData) {
      let operationFunctionMap = {
        '1': '6',
        '2': '7'
      }
      return this.$http({
        url: `/master/permissionlog/descrypt/${pageType}/${type}`,
        params: {
          query: id,
          dataMd5: md5,
          operationFunction: operationFunctionMap[pageType],
          operationType: type,
        },
        type: "POST",
      }).then((res) => {
        this.$set(formData, key, res.data.data)
      })
    }
  }
}


export const pageTool = {
  data() {
    return {
      searchParams: {},//查询参数
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      listUrl: "",
      total: 0,
      listLoading: false,
      timer: {}
    }
  },
  methods: {
    initListAjax(url) {
      this.listUrl = url;
      this.pageNum = 1;
      this.pageSize = 10;
      this.getList();
    },
    // 搜索
    searchAjax(url) {
      if (url) {
        this.listUrl = url;
      }
      this.listLoading = true;
      this.pageNum = 1;
      // this.tableData = [];
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        this.getList();
      }, 500)
    },
    setRequstType() { },
    // 设置自定义参数
    setListParams(params) { },
    //请求回调
    listCallback() { },
    finallyCallback() { },
    // ajax请求
    getList() {
      const params = Object.assign({}, this.searchParams);
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.setListParams(params);
      this.$tools.delNull(params)
      this.listLoading = true;
      if (!this.listUrl) {
        return;
      }
      this.$http({
        type: this.setRequstType() || 'PUT',
        url: this.listUrl,
        params: params
      }).then(resData => {
        this.total = resData.total;
        this.tableData = resData.data;
        this.listCallback(resData);
      }).finally(e => {
        this.listLoading = false;
        this.finallyCallback();
      });
    },
  },
}

export const ruleTool = {
  data() {
    return {
      rules: {
        // 必填规则
        required(msg = '请输入') {
          return { required: true, message: msg, trigger: 'blur' };
        },
        // 链接规则
        url(msg = '请输入正确的链接') {
          return {
            pattern: /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
            message: msg,
            trigger: 'blur'
          };
        },
        // 字数规则 isHZ 是否把汉字作2个字符计算
        count(required = true, count = [0, 10], message = '请输入', isHZ) {
          return {
            validator: function (rule, value, callback) {
              if (rule.required && !value) {
                return callback(new Error(rule.message));
              } else if (!rule.required && !value) {
                return callback();
              } else {
                if (isHZ) {
                  value = value.replace(/([^\u0000-\u00FF])/g, "**");
                }
                if (value.length >= count[0] && value.length <= count[1]) {
                  return callback();
                } else {
                  return callback(new Error(rule.message));
                }
              }
            }, required, message, trigger: 'blur'
          };
        },
        // 手机规则
        tel(msg = '请输入正确的手机号') {
          return {
            pattern: /^1[1023456789]\d{9}$/,
            message: msg,
            trigger: 'blur'
          };
        },
        // 整数规则
        num(msg = '请输入数字') {
          return {
            pattern: /^[0-9]*$/,
            message: msg,
            trigger: 'blur'
          };
        },
        // 金额规则
        money(required = true, msg = '请输入正确格式的金额') {
          return {
            validator: function (rule, value, callback) {
              if (!rule.required && !value && value !== 0) {
                return callback();
              } else {
                let reg = /^\d{1,11}(?:\.\d{1,2})?$/;
                if (reg.test(value)) {
                  return callback();
                } else {
                  return callback(new Error(rule.message));
                }
              }
            }, required: required, message: msg, trigger: 'blur'
          };
        },
      },
    }
  },
}

